import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { DialogService } from 'src/services/dialog.service';

@Injectable()
export class GlobalHttpInterceptorService implements HttpInterceptor {
  constructor(
    public router: Router,
    private dialogService: DialogService,
    // private _loading: SplashScreenStateService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // this._loading.setLoading(true, req.url);
    return next
      .handle(req)
      .pipe(
        catchError((error) => {
          if (error.status == 401) {
            const user: any = JSON.parse(localStorage.getItem('user')!);
            if(user) {
              
            var message = '';
            if (error.error.message === 'Email or password is incorrect.') {
              message = 'กรุณาใส่ข้อมูลใหม่';
            } else if (error.error.message === 'No Token Users') {
              message = 'บัญชีของคุณได้ทำการเข้าสู่ระบบที่เครื่องอื่นแล้ว';
            } else {
              message = 'กรุณาเข้าสู่ระบบใหม่อีกครั้ง';
            }

            this.dialogService.openDialog({
              action: 'fail',
              title: 'แจ้งเตือน',
              message: message
            }, () => {
              localStorage.clear();
              this.router.navigateByUrl('/auth/login');
              // if (user.isAdmin) {
              //   this.router.navigateByUrl('/admin/login');
              // } else {
              //   this.router.navigateByUrl('/client/login');
              // }
            });
            }
          }
          // this._loading.setLoading(false, req.url);
          return throwError(error);
        })
      )
      .pipe(
        map<HttpEvent<any>, any>((evt: HttpEvent<any>) => {
          if (evt instanceof HttpResponse) {
            // this._loading.setLoading(false, req.url);
          }
          return evt;
        })
      );
  }
}
